import L from 'leaflet';

export const markerIcon = (isOffice) => L.icon({
  className: 'map__marker',
  // eslint-disable-next-line no-nested-ternary
  iconUrl: typeof isOffice === 'undefined'
    ? '/front_assets/img/map/marker.svg'
    : typeof isOffice !== 'undefined' && isOffice
      ? '/front_assets/img/map/office-marker.svg'
      : '/front_assets/img/map/location-marker.svg',
  iconSize: [32, 47],
  iconAnchor: [16, 47],
  popupAnchor: [-3, -76],
});

export const popup = (locations) => {
  const div = document.createElement('div');
  div.className = 'map__popup border-1';
  div.setAttribute('data-target', 'map.popup');
  div.setAttribute('tabindex', 0);

  let button = '';
  let html = '';

  locations.forEach((data) => {
    if (typeof data.url !== 'undefined' && data.url !== '') {
      button = `
      <a href="${data.url}" class="font-weight-bold color-secondary d-inline-block mt-3">
        Bekijk vacature
      </a>
    `;
    }

    html += `
      <div class="map__popup-item">
        <button
          class="map__popup-close btn btn--sm btn--primary btn--icon-only"
          type="button"
          data-action="click->map#closePopup"
        >
          &times;
          <span class="sr-only">Close</span>
        </button>

        <div class="font-size-lg font-weight-bold">
          ${data.title}
        </div>

        <address class="text-normal mt-1">
          <a
            href="${data.googleMapsLink}"
            target="_blank"
            rel="nofollow noopener"
            class="color-secondary text-decoration-underline lheight-tight"
          >
            <div>${data.street} ${data.houseNumber}</div>
            <div class="mt-1">
                ${data.postalCode ?? ''} ${data.city}
            </div>
          </a>
        </address>

        ${button}
      </div>
    `;
  });

  div.innerHTML = `<div class="map__popup-items">${html}</div>`;

  return div;
};
